/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, {useState} from 'react';
import ArrowIcon from 'assets/svgs/actions/arrow-drop.svg';
import ActiveArrowIcon from 'assets/svgs/actions/arrow-drop-white.svg';
import DeleteIcon from 'assets/svgs/actions/icon-clear.svg';
import OutsideClickHandler from 'react-outside-click-handler';
import DefaultAvatar from 'assets/svgs/common/default-avatar.svg';

const BootstrapSelect = ({
  icon,
  iconActive,
  label,
  options,
  selected,
  onChange,
  language,
  className,
  linkClass,
  displaySelected,
  displaySelectedValue,
  isUser,
  lableProp,
  btnClass,
  enableClear,
  onClear,
  iconOnly,
  forceDisplay,
  hideName,
  noFlag,
  addBaseUrl,
  disableAvatar,
  background,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const getLabel = () => {
    if (!selected || !displaySelected) return label;

    if (typeof displaySelectedValue === 'function') {
      return displaySelectedValue(selected);
    }

    return selected.name;
  };

  const renderIcon = () => {
    if (!icon && !iconActive) {
      return null;
    }

    if (!selected || forceDisplay) {
      return (
        <>
          <img src={iconActive} className="active-img mr-3" alt="" />
          <img src={icon} className="deactive-img mr-3" alt="" />
        </>
      );
    }

    return null;
  };

  const renderButton = () => {
    if (iconOnly) {
      return <img src={icon} height={18} alt="" />;
    }
    return (
      <>
        {renderIcon()}
        {getLabel()}
        {selected ? (
          <span
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClear();
              setIsOpen(false);
            }}
          >
            <img alt="" src={DeleteIcon} className="ml-2" />
          </span>
        ) : (
          <span>
            {label === 'Status' ? (
              <>
                <img alt="" src={ArrowIcon} className="ml-2" />
              </>
            ) : isOpen ? (
              <>
                <img alt="" src={ActiveArrowIcon} className="ml-2" />
              </>
            ) : (
              <>
                <img alt="" src={ArrowIcon} className="ml-2" />
              </>
            )}
          </span>
        )}
        {/* <span
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
            setIsOpen(false);
          }}
        >
          {label === 'Status' ? (
            <>
              <img alt="" src={ArrowIcon} className="ml-2" />
            </>
          ) : selected ? (
            <>
              <img alt="" src={DeleteIcon} className="ml-2" />
            </>
          ) : isOpen ? (
            <>
              <img alt="" src={ActiveArrowIcon} className="ml-2" />
            </>
          ) : (
            <>
              <img alt="" src={ArrowIcon} className="ml-2" />
            </>
          )}
        </span> */}
        {/* {selected ? (<><img alt=""  src={DeleteIcon} className="ml-2" /></>) : (<><img alt=""  src={ArrowIcon} className="ml-2" /></>) } */}
      </>
    );
  };

  const getImage = (option) => {
    if (isUser) {
      return (
        <img
          height={30}
          width={30}
          alt=""
          src={option.avatar ? `${option.avatar}` : DefaultAvatar}
        />
      );
    }

    return (
      <img
        height={15}
        width={15}
        alt=""
        src={addBaseUrl ? `${option.avatar}` : option.avatar}
      />
    );
  };
  const statuStyle = {
    backgroundColor: background,
  };
  return (
    <div
      className={`actions-btn filter-item ${className || ''} ${
        iconOnly ? 'icon-only' : ''
      }`}
    >
      <OutsideClickHandler
        onOutsideClick={() => {
          setIsOpen(false);
        }}
      >
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}
          data-toggle="collapse"
          className={`${isOpen ? '' : 'collapsed'} text-capitalize ${
            btnClass || ''
          } d-flex justify-content-between align-items-center px-3 ${
            selected && enableClear
              ? 'justify-content-center text-white px-3 bg-eclipse'
              : selected
              ? 'justify-content-center bg-eclipse'
              : 'justify-content-center bg-white'
          } `}
          aria-expanded={isOpen}
          style={statuStyle}
        >
          {renderButton()}
        </button>

        <div className={`select-list-open collapse ${isOpen ? 'show' : ''}`}>
          <div className={`link-action ${linkClass}`}>
            {selected && enableClear && (
              <>
                {/* <a
                  href="#tst"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClear();
                    setIsOpen(false);
                  }}
                >
                  {icon && (
                    <img src={icon} className="deactive-img mr-3" alt="" />
                  )}
                  {label}
                </a>
                <hr className="m-0" /> */}
              </>
            )}

            {options.map((option, index) => {
              if (language) {
                return (
                  <React.Fragment key={option.code}>
                    <a
                      href="#test"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsOpen(!isOpen);
                        if (option.disabled) return;

                        onChange(option);
                      }}
                    >
                      {!noFlag && (
                        <span className="mr-2">
                          <img alt="" src={option.icon} width={20} />
                        </span>
                      )}
                      <span className="mr-2">{option.code}</span>{' '}
                      {hideName ? '' : option.name}
                    </a>
                    {index + 1 !== options.length && <hr className="m-0" />}
                  </React.Fragment>
                );
              }
              return (
                <React.Fragment key={option._id || option.value}>
                  <a
                    className={`${option.className || ''} ${
                      option.isDisabled ? 'disabled' : ''
                    }`}
                    href="#test"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(!isOpen);
                      if (option.isDisabled) {
                        return;
                      }
                      onChange(option);
                    }}
                  >
                    {(option.avatar || isUser) && !disableAvatar ? (
                      <span className="mr-2">{getImage(option)}</span>
                    ) : null}
                    <span className="text-capitalize">
                      {isUser
                        ? `${option.firstName} ${option.lastName}`
                        : lableProp
                        ? option[lableProp]
                        : option.label}
                    </span>
                  </a>
                  {index + 1 !== options.length && <hr className="m-0" />}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default BootstrapSelect;
